<template>
  <MasterLayout>
    <div
      class="profile__section__outer_wrapper dealler__details__wrapper"
      style="margin-top: 100px"
    >
      <div class="">
        <div
          class="account_settings_banner co_dealer_details"
          style="width: 100%; border-radius: 15px; min-height: 162px"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31, 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="banner__text_section">
            <h3 class="banner__text">{{ $t("text.dealerDetails.title") }}</h3>
          </div>
        </div>
        <div
          class="account_Settings_profile_details_section_row"
          style="margin-left: 80px"
        >
          <div class="account_Settings_profile_details_section_first_row">
            <div class="dealersDetailProfilePic" style="top: -34px">
              <img src="@/assets/img/collaboration.svg" class="" width="70%" />
            </div>
          </div>
          <div class="account_Settings_profile_details_section_second_row">
            <h5 class="profile__detail__header mt-2">
              {{ dealer.name }}<br />
              <!-- <small style="color: lightgray;font-size: 13px;">{{dealer.email}}</small> -->
            </h5>
          </div>
        </div>
      </div>
      <div class="account_Settings_profile_details_section">
        <div class="profile__form_section">
          <div class="row">
            <div
              class="col-md-12 profile__edit_form_section"
              style="box-shadow: none; flex: 0 0 80%"
            >
              <!-- <div class="row profile__form_section__row mt-5" ref="email_div">
                                <div class="col-md-10 profile__input">
                                    <h6>
                                        <input type="text" placeholder="Phone Number"  @input="captureEvents($event)"  />
                                    </h6>
                                </div>
                            </div> -->
              <div ref="email_error"></div>
              <div class="profile__form_section__row mt-5" ref="fn_div">
                <div class="row">
                  <div class="col-md-9">
                    <div class="profile__input">
                      <h6>
                        <input
                          type="text"
                          :placeholder="$t('text.dealerDetails.street')"
                          v-model="dealer.street"
                          readonly
                        />
                      </h6>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <h3 class="field__text">
                      {{ $t("text.dealerDetails.street") }}
                    </h3>
                  </div>
                </div>
              </div>
              <div ref="fn_error"></div>
              <div class="profile__form_section__row mt-5" ref="ln_error">
                <div class="row">
                  <div class="col-md-9">
                    <div class="profile__input">
                      <h6>
                        <input
                          type="text"
                          :placeholder="$t('text.dealerDetails.city')"
                          v-model="dealer.city"
                          readonly
                        />
                      </h6>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <h3 class="field__text">
                      {{ $t("text.dealerDetails.city") }}
                    </h3>
                  </div>
                </div>
              </div>
              <div ref="ln_error"></div>
              <div class="profile__form_section__row mt-5" ref="phone_div">
                <div class="row">
                  <div class="col-md-9">
                    <div class="profile__input">
                      <h6>
                        <input
                          type="text"
                          :placeholder="$t('text.dealerDetails.state')"
                          v-model="dealer.state"
                          readonly
                        />
                      </h6>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <h3 class="field__text">
                      {{ $t("text.dealerDetails.state") }}
                    </h3>
                  </div>
                </div>
              </div>
              <div ref="phone_error"></div>
              <div class="edit_profile_button mt-5 text-center">
                <router-link
                  :to="{
                    name: 'our_dealers',
                    query: { companyId: this.dealer.companyId },
                  }"
                  class="submit_btn"
                  >{{ $t("text.dealerDetails.goBack") }}
                </router-link>
                <!-- <button class="submit_btn" @click="changeRoute('our_dealers')">
                  {{ $t("text.dealerDetails.goBack") }} <span></span>
                </button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/profile_banner.png";

export default {
  title: "Dealer Details:: Epump Portal",
  name: "DealerDetail",
  components: {
    MasterLayout,
  },
  data() {
    return {
      backgroundUrl,
      dealerId: this.$route.query.dealerId,
      dealer: {},
      showConfirmedBanner: true,
      showConfirmationLoader: null,
    };
  },
  mounted() {
    this.dealerId = this.$route.query.dealerId;
    let dealers = JSON.parse(localStorage.getItem("dealers"));
    this.dealer = dealers.filter((dl) => dl.id == this.dealerId)[0];
  },
  methods: {
    // changeRoute($newRoute) {
    //   this.$router.push({ name: $newRoute });
    // },
  },
};
</script>
